import { c as _c } from "react/compiler-runtime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ActiveIncident } from "@/client/incident";
import styles from "./styles.module.css";
type Props = {
  incidents: ActiveIncident[];
};

/**
 * critical severity の incident を全画面で表示する。
 * ユーザの作業継続判断を妨げる必要があるレベルのため、閉じる操作は提供しない。
 */
export const IncidentFullScreenAlert: React.FC<Props> = t0 => {
  const $ = _c(5);
  const {
    incidents
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box className={styles.header}><ErrorOutlineIcon className={styles.icon} /><Typography variant="h4" className={styles.heading}>障害発生のお知らせ</Typography></Box>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== incidents) {
    t2 = incidents.map(_temp);
    $[1] = incidents;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Box className={styles.root} role="alert" aria-live="assertive"><Box className={styles.container}>{t1}<Box className={styles.list}>{t2}</Box></Box></Box>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(incident) {
  return <Box key={incident.id} className={styles.item}><Typography variant="h5" className={styles.title}>{incident.title}</Typography><Typography variant="body1" className={styles.body}>{incident.body}</Typography></Box>;
}